import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { PpiCalc } from "../components/PpiCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.ppi_tool_name()}
        toolPath="/ppi-calculator"
      />
      <SciHeader title={m.ppi_h1()} intro={m.ppi_intro()} />
      <PpiCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.ppi_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.ppi_ex1(), m.ppi_ex2(), m.ppi_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.ppi_faq_q1(), a: m.ppi_faq_a1() },
          { q: m.ppi_faq_q2(), a: m.ppi_faq_a2() },
          { q: m.ppi_faq_q3(), a: m.ppi_faq_a3() },
          { q: m.ppi_faq_q4(), a: m.ppi_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
